import React from "react";
import { getCountryLabel } from "../utils/projectUtils";
import { usesUkStyleLocality } from "../constants/countryAddress";

function hasAnyProjectAddress(project) {
  if (!project) return false;
  return Boolean(
    project.street_address ||
      project.city ||
      project.state ||
      project.postal_code
  );
}

/**
 * Read-only project site address on the home dashboard (above the submittal summary).
 */
export default function ProjectSiteAddressBanner({ project }) {
  if (!hasAnyProjectAddress(project)) return null;

  const lines = [];
  if (project.street_address) {
    lines.push(project.street_address);
  }

  const countryCode = (project.country_code || "usa").toLowerCase();
  const locality =
    usesUkStyleLocality(countryCode)
      ? [project.city, project.state, project.postal_code]
          .filter(Boolean)
          .join(", ")
      : [
          project.city,
          [project.state, project.postal_code].filter(Boolean).join(" "),
        ]
          .filter(Boolean)
          .join(", ");
  if (locality) {
    lines.push(locality);
  }

  const countryLabel = getCountryLabel(project.country_code || "usa");
  if (countryLabel) {
    lines.push(countryLabel);
  }

  const addressText = lines.join(", ");

  return (
    <div className="mb-4 pb-4 border-b border-slate-200/90 flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500 shrink-0">
        Project site address:
      </span>
      <span className="text-sm text-slate-800 min-w-0">{addressText}</span>
    </div>
  );
}
